import { Box, Container, styled } from '@material-ui/core';

const DottedLine = styled(Box)(({ theme }) => ({
  borderBottom: '2px dashed',
  width: '100%',
  margin: '0 auto',
  color: theme.palette.primary.main,
  marginTop: theme.spacing(22),
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(13.3),
  },
}));
const Divider = () => {
  return (
    <Container fixed>
      <DottedLine />
    </Container>
  );
};

export default Divider;
